// ***************************************************************************************************


export const directDownloadJson = (url, callbackfn, infos) =>{
    var myHeaders = new Headers();
    myHeaders.append('Accept','application/json');
    myHeaders.append('Content-Type','application/json');


    var myInit = { method: 'POST',
        Headers: myHeaders,
        mode: 'cors',
         };    
    fetch (url, myInit)
    .then (response =>    {
        if (response.ok)
        {
            
            return response.json();
        }

    })
    .then (data => {
        callbackfn(data, infos, url)

    })

    .catch((err) => {
        console.log(err);
    });
}
  
export const directDownloadTxt = (url, callbackfn, infos) =>{
    var myHeaders = new Headers();
    myHeaders.append('Accept','application/json');
    myHeaders.append('Content-Type','application/json');


    var myInit = { method: 'POST',
        Headers: myHeaders,
        mode: 'cors',
         };    
    fetch (url, myInit)
    .then (response =>    {
        if (response.ok)
             return response.text();

    })
    .then (data => {
        
        callbackfn(data, infos, url)

    })

    .catch((err) => {
        console.log(err);
    });
}



export const directDownloadBinary = (url, callbackfn, infos) =>{


    fetch(url, {
        method: "GET",
        mode:"cors",
        headers: {
            "Accept": "application/octet-stream"  // On s'attend à recevoir des données binaires
        }
    })
    .then(response => response.arrayBuffer())  // Convertir la réponse en ArrayBuffer (données binaires)
    .then(arrayBuffer => {
        // Vous pouvez traiter les données binaires ici


        const byteArray = new Uint8Array(arrayBuffer);
        
        callbackfn(byteArray, infos, url)
        
    })
    .catch(error => console.error('Err :', error));


}
  

export function getStickyWordsList(utf8String)
{

    var list = [];
    utf8String.split(";").forEach(word =>{
        if (word.trim()!="")        
            list.push(word.trim().toUpperCase());
    })
    return list;
}
